import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolGradient from '../../../types/gradient'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import CreationToolWatermarkPosition from '../../../types/watermark'
import { StaircaseIcon } from '../../icons'
import SegmentedControl from '../../segmented-control'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import FieldTitle from './field-title'

const Container = styled.div`
    grid-column: span 2;
`

const Ass = styled(StaircaseIcon)<{ rotation: number }>`
    height: 20px;
    transform: rotate(${props => props.rotation}deg);
`

type Props = {
    field: CreationToolSuperCutField
    defaultPosition?: CreationToolWatermarkPosition
    gradient?: CreationToolGradient
}

const CreationCaptureWatermarkPositionSlider = ({
    defaultPosition,
    field,
    gradient = CreationToolGradient.PurpleRed,
}: Props) => {
    const { watermark, previousWatermarks, setWatermarkPosition } = useContext(CreationCaptureInfoContext)
    const allPositions = CreationToolWatermarkPosition.all()

    const icons = allPositions.map((pos, i) => {
        return <Ass key={i} rotation={CreationToolWatermarkPosition.rotation(pos)} />
    })

    const onChange = (index: number) => {
        setWatermarkPosition(allPositions[index])
    }

    return (
        <>
            {previousWatermarks.length > 0 && watermark ? (
                <Container>
                    <FieldTitle field={field} />
                    <SegmentedControl
                        {...{
                            gradient,
                            items: icons,
                            defaultIndex: defaultPosition ? allPositions.indexOf(defaultPosition) : undefined,
                            onIndexChange: index => onChange(index),
                        }}
                    />
                </Container>
            ) : null}
        </>
    )
}

export default CreationCaptureWatermarkPositionSlider
